module.exports = __webpack_public_path__ + "img/10.c072794c.jpg";